import React from "react";
import { ComboAddonList } from "../features/combos";
import { withRestaurantId } from "../shared/components/layout";

const ComboAddonListWithId = withRestaurantId(ComboAddonList);

const ComboAddonsPage: React.FC = () => {
  return <ComboAddonListWithId />;
};

export default ComboAddonsPage;
